import React, { useState } from 'react'
import ProgramCard from './ProgramCard'
import ProgramOverlay from './ProgramOverlay'
import ScheduleOverlay from './ScheduleOverlay'
import api from '../../../services/api'
import '../../../css/programList.css'

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))

const ProgramList = ({
  programs,
  schedules,
  episodes,
  refreshProgramsList,
  peopleList,
  topicList,
  companyList = [],
  rubricaList = [],
  onForceRemount,
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedProgram, setSelectedProgram] = useState(null)
  const [selectedProgramForSchedule, setSelectedProgramForSchedule] = useState(null)

  const openDetailsModal = (programData) => {
    setSelectedProgram(programData)
  }

  const closeDetailsModal = () => {
    setSelectedProgram(null)
  }

  const handleViewDetails = async (id) => {
    try {
      const response = await api.get(`/programs/${id}`, {
        headers: { 'Content-Type': 'application/json' },
      })
      openDetailsModal(response.data)
    } catch (error) {
      console.error('handleViewDetails error:', error)
    }
  }

  const handleEdit = async (id, editedData) => {
    try {
      
      await api.put(`/programs/${id}`, editedData, {
        headers: { 'Content-Type': 'application/json' },
        timeout: 45000,
      })

     
      const getResponse = await api.get(`/programs/${id}`)
      let updatedProgram = getResponse.data

      if (updatedProgram.image_url) {
        const [base] = updatedProgram.image_url.split('?')
        updatedProgram.image_url = `${base}?t=${Date.now()}`
      }

      setSelectedProgram({ ...updatedProgram })

      
      await refreshProgramsList()
      // window.location.reload();

      
      if (onForceRemount) {
        onForceRemount()
      }

      

    } catch (error) {
      console.error('handleEdit error:', error)
      throw error
    }
  }

  const handleDelete = async (id) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo programma?')) return
    try {
      await api.delete(`/programs/${id}`)
      refreshProgramsList()
    } catch (error) {
      console.error('handleDelete error:', error)
    }
  }

  const handleSchedule = (id) => {
    const programData = programs.find(p => p.id === id)
    if (programData) {
      setSelectedProgramForSchedule(programData)
    }
  }

  const filteredPrograms = programs.filter(program =>
    program.title.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <>
      <div className="programlist-content">
        <input
          type="text"
          placeholder="Cerca Programmi..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="program-search"
        />
        <div className="programlist-cards-container">
          {filteredPrograms.map((program) => (
            <ProgramCard
              key={program.id}
              program={program}
              schedules={schedules}
              episodes={episodes}
              onSchedule={handleSchedule}
              onDelete={handleDelete}
              onViewDetails={handleViewDetails}
            />
          ))}
        </div>
      </div>

      {selectedProgram && (
        <ProgramOverlay
          key={`${selectedProgram.id}-${selectedProgram.image_url || ''}`}
          program={selectedProgram}
          schedules={schedules}
          onClose={closeDetailsModal}
          onEdit={handleEdit}
          peopleList={peopleList}
          topicList={topicList}
        />
      )}

      {selectedProgramForSchedule && (
        <ScheduleOverlay
          program={selectedProgramForSchedule}
          schedules={schedules}
          onClose={() => setSelectedProgramForSchedule(null)}
          onScheduleUpdate={async (programId, updatedSchedules) => {
            try {
              if (!updatedSchedules.length) {
                setSelectedProgramForSchedule(null)
                return
              }
              await api.put(
                `/programs/${programId}/schedules`,
                { schedules: updatedSchedules },
                {
                  headers: { 'Content-Type': 'application/json' },
                  timeout: 45000,
                }
              )
              refreshProgramsList()
              setSelectedProgramForSchedule(null)
            } catch (error) {
              console.error('Errore scheduling:', error)
              throw error
            }
          }}
          refreshProgramsList={refreshProgramsList}
          peopleList={peopleList}
          topicList={topicList}
          companyList={companyList}
          rubricaList={rubricaList}
        />
      )}
    </>
  )
}

export default ProgramList
